const branchInfo = {
	uuid: "",
	branch_name: "AGIC Online",
	receipt_branch_name: "AGIC Online",
	branch_id: "AGIO",
	branch_email: process.env.REACT_APP_BRANCH_EMAIL,
	tablet_id: "1",
	tablet_type: "Customer Tablet",
};

// Feature flags
export const FEATURE_FLAGS = {
	ENABLE_COMMERCIAL_DRIVER_LICENSE_VALIDATION: process.env.REACT_APP_ENABLE_COMMERCIAL_DRIVER_LICENSE_VALIDATION === "true" || process.env.REACT_APP_ENABLE_COMMERCIAL_DRIVER_LICENSE_VALIDATION === "1",
};

export default branchInfo;
